module.exports = __webpack_public_path__ + "img/wkdp.59d8539f.png";